import { render, staticRenderFns } from "./DetailEmployeeView.vue?vue&type=template&id=546cb8de&scoped=true"
import script from "./DetailEmployeeView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailEmployeeView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DetailEmployeeView.vue?vue&type=style&index=0&id=546cb8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546cb8de",
  null
  
)

export default component.exports